import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import {SharedModule} from '../../shared/shared.module';
import {CurrencyComponent} from './currency-list/currency.component';
import {CurrencyUpdateComponent} from './currency-update/currency-update.component';
import {currencyRoute} from './currency.route';

@NgModule({
  imports: [SharedModule, RouterModule.forChild(currencyRoute)],
  declarations: [CurrencyComponent, CurrencyUpdateComponent],
})
export class CurrencyModule {}
